import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import {Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import Dialog from '@material-ui/core/Dialog';
import InputAdornment from '@mui/material/InputAdornment';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@mui/material/TextField';
import moment from 'moment';
import axios from 'axios';
import ContactsSelect from '../contacts/ContactsSelect';
import Alert from '../components/Alert';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});


const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  const [open, setOpen] = React.useState(false); 
  const childRefAlert = React.useRef(); 
  const childRefContacts = React.useRef();
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [alertMessage, setAlertMessage] = React.useState("");
  
  const [accountNumber, setAccountNumber] = React.useState("");
  const [accountName, setAccountName] = React.useState("");
  const [accountId, setAccountId] = React.useState("");
  const [amount, setAmount] = React.useState("");
  const [paymentMode, setPaymentMode] = React.useState("");
  const [paymentStatus, setPaymentStatus] = React.useState("Progress");
  const [transactionType, setTransactionType] = React.useState("Credit");
  const [bankAccount, setBankAccount] = React.useState("");
  const [remarks, setRemarks] = React.useState("");
  const [transactionId, setTransactionId] = React.useState("");
  const [invoiceNumber, setInvoiceNumber] = React.useState("");
  const [referenceNumber, setReferenceNumber] = React.useState("");
  const [paymentDate, setPaymentDate] = React.useState(moment(new Date()).format('YYYY-MM-DD'));
  const [ownerAlias, setOwnerAlias] = React.useState("");
  const [ownerId, setOwnerId] = React.useState(0);

  const [paymentModeList, setPaymentModeList] = React.useState([]);
  const [paymentBanksList, setPaymentBanksList] = React.useState([]);

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {	
    if(open){
      getApiDataMultiple();
    }

    if(props.userObj && open && props.dataObj && props.dataObj?.autoId>0){

      setAccountNumber(props.dataObj.accountNumber);
      setAccountName(props.dataObj.accountName);
      setAccountId(props.dataObj.accountId);
      setAmount(props.dataObj.amount);
      setPaymentMode(props.dataObj.paymentMode);
      setPaymentStatus(props.dataObj.status);
      setTransactionType(props.dataObj.transactionType);
      
      if(props.dataObj.bankAccountName && props.dataObj.bankAccountNumber && props.dataObj.bankName){
        setBankAccount(props.dataObj.bankAccountName+'#'+props.dataObj.bankAccountNumber+'#'+props.dataObj.bankName);
      }

      setRemarks(props.dataObj.remarks);
      setTransactionId(props.dataObj.transactionId);
      setInvoiceNumber(props.dataObj.invoiceNumber);
      setReferenceNumber(props.dataObj.referenceNumber);
      if(props.dataObj.paymentDate){
        let dateArr = props.dataObj.paymentDate.split("-");
        setPaymentDate(moment(new Date(dateArr[2]+"-"+dateArr[1]+"-"+dateArr[0])).format('YYYY-MM-DD'))
      }

      if(props.dataObj.ownerId>0){
        setOwnerAlias(props.dataObj.ownerAlias);
        setOwnerId(props.dataObj.ownerId);

      }else if(props.userObj && props.userObj.fullName){
        setOwnerAlias(props.userObj.fullName);
        setOwnerId(props.userObj.userId);
      }

    }else{

      setAccountNumber("");
      setAccountName("");
      setAccountId("");
      setAmount("");
      setPaymentMode("");
      setPaymentStatus("Progress");
      setTransactionType("Credit");
      setBankAccount("");
      setRemarks("");
      setTransactionId("");
      setInvoiceNumber("");
      setReferenceNumber("");
      setPaymentDate(moment(new Date()).format('YYYY-MM-DD'));
      
      if(open && props.relatedDataObj?.accountId>0){
        setAccountNumber(props.relatedDataObj?.accountNumber);
        setAccountName(props.relatedDataObj?.accountName);
        setAccountId(props.relatedDataObj?.accountId);
      }

      if(props.userObj && props.userObj.fullName){
        setOwnerAlias(props.userObj.fullName);
        setOwnerId(props.userObj.userId);
      }else{
        setOwnerAlias("");
        setOwnerId(0);
      }

    }

	}, [props.userObj,props.dataObj,props.relatedDataObj,open]);
  

	function saveData(){
    if(!amount){
      setSeverityAlert("error");
      setAlertMessage("Enter amount");	
      childRefAlert.current.handleClickOpen();		
      return false;
    }
    if(!paymentMode){
      setSeverityAlert("error");
      setAlertMessage("Enter payment mode");	
      childRefAlert.current.handleClickOpen();		
      return false;
    }
    if(!accountName){
      setSeverityAlert("error");
      setAlertMessage("Enter account name");	
      childRefAlert.current.handleClickOpen();		
      return false;
    }

		if(amount && paymentMode && accountName && accountName.length>0){ 
			let axiosHeader = {
        headers: {
          'Content-Type': 'multipart/mixed',
          'device': 'web',
          'registerId': props.userObj.registerId,
          'uid': props.userObj.loginId,
          'fullName': props.userObj.fullName,
          'token': props.userObj.token,
        }
      };

      const data = new FormData();
      if(props.dataObj && props.dataObj?.autoId>0){
        data.append('paymentId', props.dataObj?.autoId);
      } 
      data.append('relatedToId', props.relatedDataObj?.autoId);
      data.append('relatedTo', props.relatedTo);      
      data.append('accountNumber', accountNumber);
      data.append('accountName', accountName);
      data.append('accountId', accountId);
      data.append('amount', amount);
      data.append('paymentMode', paymentMode);
      data.append('status', paymentStatus);
      data.append('transactionType', transactionType);
      
      if(bankAccount && bankAccount.length>3){
        let baArr = bankAccount.split("#");        
        data.append('bankAccountName', baArr[0]);
        data.append('bankAccountNumber', baArr[1]);
        data.append('bankName', baArr[2]);
      }

      data.append('remarks', remarks);
      data.append('transactionId', transactionId);
      data.append('invoiceNumber', invoiceNumber);
      data.append('referenceNumber', referenceNumber);
      data.append('paymentDate', moment(paymentDate).format('YYYY-MM-DD'));

      if(props.fullList===true){
        data.append('fullList', 1);
      }else{
        data.append('fullList', 0);
      }

      data.append('ownerId', ownerId);
      data.append('ownerAlias', ownerAlias);
      
      let apiURL='/crm-create-payments';
      if(props.dataObj!=null && props.dataObj.autoId){
          apiURL='/crm-update-payments';
      }
             
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);					
					setAlertMessage("Payment has been saved.");
          childRefAlert.current.handleClickOpen();	
          props.updatedList(response.data.list);	
					return false;

				}else if(response.data.responseTxt==="invalidtoken"){
					window.location.href='invalidtoken';

				}else{
          setSeverityAlert("error");					
					setAlertMessage("Payment could not be saved.");	
          childRefAlert.current.handleClickOpen();			
					return false;
				}
			})
			.catch((error) => {
				  setSeverityAlert("error");
					setAlertMessage(""+error);			
          childRefAlert.current.handleClickOpen();	
					return false;
			})	
		}		
	}

  async function getApiDataMultiple(){
		let axiosHeader = {
		  headers: {
			'Content-Type': 'multipart/mixed',
			'device': 'web',
			'registerId': props.userObj.registerId,
			'uid': props.userObj.loginId,
			'fullName': props.userObj.fullName,
			'token': props.userObj.token,
		  }
		};
    axios.get(API_URL+'/crmix-for-newpayment', axiosHeader)
       .then(response => {
      if(response && response.data && response.data.responseTxt==="success"){ 
        setPaymentModeList(response.data.obj.paymentModes);
        setPaymentBanksList(response.data.obj.paymentBanks);
      }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
        window.location.href='invalidtoken';
      } 		 				
    }).catch((error) => {
          setSeverityAlert("error");
					setAlertMessage(""+error);			
          childRefAlert.current.handleClickOpen();	
					return false;
      })
  }

  function selectContacts(){
     childRefContacts.current.handleClickOpen();
  }
  function contactDetail(obj){    
    setAccountId(obj.accountId);
    setAccountName(obj.accountName);
    setAccountNumber(obj.accountNumber);
    // setContactName(obj.contactName);
    // setMobile(obj.mobile);
    // setEmail(obj.email);
    // setAddress(obj.address);
    // setCity(obj.city);
    // setState(obj.state);
    // setPincode(obj.zipCode);
    // setCountry(obj.country);
    
  }

  // function numberOnly(event){
  //   if (!/[0-9]/.test(event.key)) {
  //     event.preventDefault();
  //   } 
  // }

  function decimalOnly(event){
    var charCode = (event.which) ? event.which : event.keyCode
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
    event.preventDefault();
    return true;
  }
  
  return (
    <>
      <Dialog  maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}>{(props.dataObj!=null && props.dataObj.autoId)?<>Edit</>:<>New</>} Payment</DialogTitle>
          <DialogContent >
            <Grid item md={12} xs={12} >                  
                  <Box mt={2} mb={1} >
						        <Grid container spacing={2}>
                          <Grid item md={6} xs={12} >
                              <TextField size='small' label="Amount" onChange={event => setAmount(event.target.value)} onKeyPress={(event)=>{decimalOnly(event)}} value={amount} fullWidth variant="outlined" /> 
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label">Payment Mode</InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={paymentMode}
                                  label="Payment Mode"                                  
                                  onChange={event => setPaymentMode(event.target.value)}
                                >
                                  {paymentModeList?paymentModeList.map((myRow,mykey)=>(
                                    <MenuItem key={'at'+mykey} value={myRow.title}>{myRow.title}</MenuItem>
                                  )):null}
                                </Select>
                              </FormControl>
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField size='small' type='date' label="Transaction Date" onChange={event => setPaymentDate(event.target.value)} value={paymentDate} fullWidth variant="outlined" />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <TextField size='small' label="Transaction Id" onChange={event => setTransactionId(event.target.value)} value={transactionId} fullWidth variant="outlined" />
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label">Payment Status</InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={paymentStatus}
                                  label="Payment Status"                                  
                                  onChange={event => setPaymentStatus(event.target.value)}
                                >
                                    <MenuItem value="Progress" >Progress</MenuItem>
                                    <MenuItem value="Failed" >Failed</MenuItem>
                                    <MenuItem value="Bounced" >Bounced</MenuItem>
                                    <MenuItem value="Refunded" >Refunded</MenuItem>
                                    <MenuItem value="Completed" >Completed</MenuItem>                                    
                                </Select>
                              </FormControl>    
                          </Grid>
                          <Grid item md={6} xs={12} >
                              <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label">Transaction Type</InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={transactionType}
                                  label="Transaction Type"                                  
                                  onChange={event => setTransactionType(event.target.value)}
                                >
                                    <MenuItem value="Credit" >Credit</MenuItem>
                                    <MenuItem value="Debit" >Debit</MenuItem>
                                </Select>
                              </FormControl>    
                          </Grid>                          
                          <Grid item md={6} xs={12} >
                              <TextField
                               label="Account Name"
                               onChange={event => setAccountName(event.target.value)}
                               value={accountName}
                               fullWidth
                               size='small'
                               variant="outlined"
                               InputProps={{
                                readOnly: true,
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <SavedSearchIcon style={{cursor:'pointer'}} onClick={()=>{selectContacts()}} />
                                  </InputAdornment>
                                ),
                                }}
                               />      
                          </Grid>                          
                          <Grid item md={6} xs={12} >
                              <TextField size='small' label="Invoice Number" onChange={event => setInvoiceNumber(event.target.value)} value={invoiceNumber} fullWidth variant="outlined" />
                          </Grid>
                          <Grid item md={6} xs={12} >
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label">Bank Account</InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={bankAccount}
                                  label="Bank Account"                                  
                                  onChange={event => setBankAccount(event.target.value)}
                                >
                                  <MenuItem value="" >Select</MenuItem> 
                                  {paymentBanksList?paymentBanksList.map((myRow,mykey)=>(
                                    <MenuItem key={'at'+mykey} value={myRow.bankAccountName+'#'+myRow.bankAccountNumber+'#'+myRow.bankName} >{myRow.bankAccountName} {myRow.bankAccountNumber} {myRow.bankName}</MenuItem>
                                  )):null}
                                </Select>
                              </FormControl>    
                          </Grid> 
                          <Grid item md={6} xs={12} >
                              <TextField size='small' label="Reference Number" onChange={event => setReferenceNumber(event.target.value)} value={referenceNumber} fullWidth variant="outlined" />
                          </Grid>                           
                          <Grid item md={6} xs={12} >
                              <TextField size='small' label="Remarks" onChange={event => setRemarks(event.target.value)} value={remarks} fullWidth variant="outlined" multiline />
                          </Grid>
                    </Grid>
                  </Box>        

                  <Box mt={1} mb={1} >
						        <Grid container spacing={2}>
                          <Grid item md={12} xs={12} >
                            <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
                            <Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
                          </Grid>
                    </Grid>
                  </Box>              

            </Grid>
          </DialogContent>
      </Dialog>
      
      <Alert severityAlert={severityAlert} alertMessage={alertMessage} ref={childRefAlert} /> 
      <ContactsSelect userObj={props.userObj} contactDetail={contactDetail} ref={childRefContacts} />

        
        
    </>
  );

});

export default CustomizedDialogs;